import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, StafferTrophiesResponse } from "@/types";

export const stafferTrophiesQueryKey = ["staffer-trophies"] as const;

export const useGetStafferTrophies = () =>
  useQuery({
    queryKey: stafferTrophiesQueryKey,
    queryFn: async () => {
      const res = await guacHttpClient.get<
        StafferTrophiesResponse,
        HttpResponse<StafferTrophiesResponse>
      >("staffer-metrics/trophies");
      return res.data;
    },
  });
